import React from 'react';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { PageSection, SectionBody, SectionHeader } from './PageSection';
import { Text, Heading, Box } from 'grommet';
import Link from './Link';

const StyledProductItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  width: 240px;
  margin-bottom: 30px;
  
`;

const ProductItem = ({ name, ctaUrl, ctaLabel, title, image }) => {
  return (
    <StyledProductItem>
      <Box width={{ max: '240px' }}>
        <GatsbyImage image={image.gatsbyImageData} alt={image.description} />
      </Box>
      <Heading level="6">{name}</Heading>
      <Text>
        <Link href={ctaUrl}>{ctaLabel}</Link>
      </Text>
    </StyledProductItem>
  );
};

const StyledSectionBody = styled(SectionBody)`
  > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;

    // @media ${({ theme }) => theme.custom.layouts.below_medium} {
    //   grid-template-columns: auto;
    // }
    // @media ${({ theme }) => theme.custom.layouts.only_medium} {
    //   grid-template-columns: repeat(6, 1fr);

    //   > div {
    //     grid-column: span 2;

    //     &:last-child:nth-child(3n - 1) {
    //       grid-column-end: -2;
    //     }

    //     &:nth-last-child(2):nth-child(3n + 1) {
    //       grid-column-end: 4;
    //     }
    //     /* Dealing with single orphan */

    //     &:last-child:nth-child(3n - 2) {
    //       grid-column-end: 5;
    //     }
    //   }
    // }
    // @media ${({ theme }) => theme.custom.layouts.above_large} {
    //   grid-template-columns: repeat(4, 1fr);
    // }
  }
`;

export const ProductListingSection = ({ title, items }) => {
  return (
    <PageSection>
      <SectionHeader title={title}></SectionHeader>
      <StyledSectionBody>
        <div>
          {items.map((item, i) => (
            <ProductItem key={`productListingItem${i}`} {...item} />
          ))}
        </div>
      </StyledSectionBody>
    </PageSection>
  );
};
